export default __webpack_public_path__ + "static/media/download.be8f6ca5.svg";